export default {
    namespaced: true,
    state: {
        soft: '云飞阁',
        version: '1.0.0',
        new_name: "聚源书屋",
        name: "", //用户名
        term: "", //期限
        fen: 0, //分量
        notice: "", //通知
    },
    mutations: {
        changeName(state, payload) {
            state.name = payload;
            localStorage.setItem("name", payload);
        },
        changeTerm(state, payload) {
            state.term = payload;
            localStorage.setItem("term", payload);
        },
        changeNotice(state, payload) {
            state.notice = payload;
            localStorage.setItem("notice", payload);
        },
        changeFen(state, payload) {
            state.fen = payload;
            localStorage.setItem("fen", payload);
        },
    }
}